<div class="lang-modal">
  <div class="lang-modal__header">
    <span class="lang-modal__title">{{ 'language.title' | transloco }}</span>
  </div>

  <div class="lang-modal__grid">
    @for (lang of languages; track $index) {
    <button class="lang-card" [class.lang-card--active]="lang.code === activeLang" (click)="setLang(lang.code)">
      <img class="lang-card__flag" [src]="lang.icon" [alt]="lang.label | transloco">
      <span class="lang-card__name">{{ lang.label | transloco }}</span>
      @if (lang.code === activeLang) {
      <span class="lang-card__check">
        <i class="sdx sdx-check"></i>
      </span>
      }
    </button>
    }
  </div>

  <div class="lang-modal__footer">
    <button type="button" class="lang-cancel-btn" (click)="cancel()">
      {{ 'label.cancel' | transloco }}
    </button>
  </div>
</div>